import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './utils/rem'

import './style_import'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import FcIcon from '@/components/views/fc_icon'
import CommonImg from '@/components/views/common_img'
import CommonTabs from '@/components/views/common_tabs'
import TipDlg from '@/components/views/tip_dlg'
import ListLoading from '@/components/views/loading'
import BottomTip from '@/components/views/bottom_tip'
import Picker from '@/components/views/picker'
import DatePicker from '@/components/views/date_picker'
import PageWrap from '@/components/page_wrap'

import GlobalUtils from '@/plugins/global_utils'
import WatchRoute from '@/plugins/watch_route'
import GlobalData from '@/plugins/global_data'

import Navigation from 'vue-navigation'

import GftTabs from '@/components/gft/gft-tabs'
import GftOverlay from '@/components/gft/gft-overlay'
import GftSearchInput from '@/components/gft/gft-search-input'
import GftSearchInputWrap from '@/components/gft/gft-search-input-wrap'
import GftSearchWrap from '@/components/gft/gft-search-wrap'
import GftSearchLoading from '@/components/gft/gft-search-loading'
import GftModal from '@/components/gft/gft-modal'

import FangchanCommonTabs from '@/components/fangchan/fangchan-common-tabs'
import FangchanSlogan from '@/components/fangchan/fangchan-slogan'
import FangchanDisclaimer from '@/components/fangchan/fangchan-disclaimer'
import FangchanHeadImg from '@/components/fangchan/fangchan-head-img'
import FangchanFloatQuestion from '@/components/fangchan/fangchan-float-question'

import FangchanConsultantPromise from '@/components/fangchan/fangchan-consultant-promise'
import FangchanCommonArticle from '@/components/fangchan/fangchan-common-article'
import FangchanEmptyBox from '@/components/fangchan/fangchan-empty-box'

import VanDatetimePicker from 'vant/lib/datetime-picker'
import { Swipe, SwipeItem } from 'vant'


Vue.use(VanDatetimePicker)
Vue.use(Swipe)
Vue.use(SwipeItem)

Vue.component('page-wrap', PageWrap)
Vue.component('common-img', CommonImg)
Vue.component('fc-icon', FcIcon)
Vue.component('common-tabs', CommonTabs)
Vue.component('tip-dlg', TipDlg)
Vue.component('list-loading', ListLoading)
Vue.component('picker', Picker)
Vue.component('date-picker', DatePicker)
Vue.component('bottom-tip', BottomTip)
Vue.component('fangchan-head-img', FangchanHeadImg)

Vue.component('gft-tabs', GftTabs)
Vue.component('gft-overlay', GftOverlay)
Vue.component('gft-search-input', GftSearchInput)
Vue.component('gft-search-input-wrap', GftSearchInputWrap)
Vue.component('gft-search-wrap', GftSearchWrap)
Vue.component('gft-search-loading', GftSearchLoading)
Vue.component('gft-modal', GftModal)


Vue.component('fangchan-common-tabs', FangchanCommonTabs)
Vue.component('fangchan-slogan', FangchanSlogan)
Vue.component('fangchan-disclaimer', FangchanDisclaimer)
Vue.component('fangchan-head-img', FangchanHeadImg)
Vue.component('fangchan-consultant-promise', FangchanConsultantPromise)
Vue.component('fangchan-common-article', FangchanCommonArticle)
Vue.component('fangchan-empty-box', FangchanEmptyBox)
Vue.component('fangchan-float-question', FangchanFloatQuestion)


Vue.use(Navigation, {router})
Vue.use(VueAwesomeSwiper)
Vue.use(WatchRoute)
Vue.use(GlobalUtils)
Vue.use(GlobalData)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
